import { ChangeDetectionStrategy, Component, input, OnInit, output, signal } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { InputSelectOption } from "@components/shared/inputs/input-select/input-select.model";
import { TextConstants } from "@shared/constants";
import { RulesetResourceTypeEnum } from "@shared/enums";
import { IConditionForm } from "@shared/interfaces";
import { LocalizationUtils } from "@shared/utils";

@Component({
  standalone: false,
  selector: "app-ruleset-info",
  templateUrl: "./ruleset-info.component.html",
  styleUrl: "./ruleset-info.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RulesetInfoComponent implements OnInit {
  resourceType = input.required<RulesetResourceTypeEnum>();

  formGroup = input.required<FormGroup>();

  countryOptions = input.required<InputSelectOption[]>();

  propertyOptions = input.required<InputSelectOption[]>();

  locationTypeOptions = input<InputSelectOption[]>();

  locationOptions = input<InputSelectOption[]>();

  addCriteria = output<FormGroup>();

  removeCriteria = output<{ formGroup: FormGroup; index: number }>();

  isLoading = signal(true);

  public readonly mainInformationText = TextConstants.MAIN_INFORMATION;

  public readonly translations: any = {
    nameLabel: TextConstants.NAME,
    descriptionLabel: TextConstants.DESCRIPTION,
  };

  public ngOnInit(): void {
    const resourceTypeLowercase = this.resourceType();
    const entityTypeLowercase = LocalizationUtils.getEntityType(
      resourceTypeLowercase,
      false,
      "lowercase",
    );
    const entityTypeLowercasePlural = LocalizationUtils.getEntityType(
      resourceTypeLowercase,
      true,
      "lowercase",
    );

    this.translations.criteriaTp = $localize`:@@ruleset-info.specifyruleset:Specify the characteristics of the ${entityTypeLowercasePlural}:entityNamePlural: to which this ruleset should apply`;
    this.translations.expectationsTp = $localize`:@@ruleset-info.specifyexpectations:Specify which expectations need to be met for the ${entityTypeLowercase}:entityName: not to be flagged as not meeting the ruleset requirements`;
    this.translations.noCriteriaHint = $localize`:@@ruleset-info.nocriteriahint:Specifying no criteria will make the ruleset applicable to all ${entityTypeLowercasePlural}:entityNamePlural:.`;
    this.translations.specifyDocument = $localize`:@@ruleset-info.specifydocument:Specify which documents should be attached to a ${entityTypeLowercase}:entityName: based on the ruleset criteria.
            At least one should be specified.`;

    this.isLoading.set(false);
  }

  get conditionFormGroup() {
    return this.formGroup().get("condition") as FormGroup<IConditionForm>;
  }
}
